export const legendLabelFormat = (label: string): string => {
  if (label === "Registered") return "Users who registered for this event.";
  if (label === "Attended") return "Users who attended this event.";
  return "Users who registered for this event, but did not attend.";
};
